import { Component, OnInit, inject } from '@angular/core';
import { DialogService } from '@next/core-lib/dialog';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';

import { SoilAnalysisDesignations } from './models/soil-analysis.model';
import { SoilAnalysisCompleteViewDialogComponent } from './soil-analysis-complete-view-dialog/soil-analysis-complete-view-dialog.component';
import * as SoilAnalysisSelectors from '../advice/store/selectors';
import { SoilAnalysis } from '../shared/models';

@Component({
  selector: 'app-soil-analysis-quick-view',
  templateUrl: './soil-analysis-quick-view.component.html',
  styleUrls: ['./soil-analysis-quick-view.component.scss'],
  standalone: false,
})
export class SoilAnalysisQuickViewComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly dialogService = inject(DialogService);

  soilAnalysis$ = this.store.pipe(select(SoilAnalysisSelectors.selectLatestSoilAnalysis));
  year: string;
  pal: string;
  ppae: string;
  pw: string;
  private soilAnalysis: SoilAnalysis;

  ngOnInit() {
    this.soilAnalysis$.subscribe((s) => {
      this.soilAnalysis = s;
      this.year = s
        ? s.isDefault
          ? '-'
          : new Date(s.samplingDateTime)?.getFullYear()?.toString() ?? '-'
        : '-';
      this.pal = this.formatCharacteristicValue(
        s?.sampledCharacteristics?.filter((c) => c.designation === SoilAnalysisDesignations.pAl)[0]
          ?.value,
        SoilAnalysisDesignations.pAl,
      );
      this.ppae = this.formatCharacteristicValue(
        s?.sampledCharacteristics?.filter((c) => c.designation === SoilAnalysisDesignations.pPae)[0]
          ?.value,
        SoilAnalysisDesignations.pPae,
      );
      this.pw = this.formatCharacteristicValue(
        s?.sampledCharacteristics?.filter((c) => c.designation === SoilAnalysisDesignations.pw)[0]
          ?.value,
        SoilAnalysisDesignations.pw,
      );
    });
  }

  showCompleteViewDialog() {
    this.dialogService.responsiveDialog(SoilAnalysisCompleteViewDialogComponent, {
      fullscreen: true,
      cancelButton: false,
      soilAnalysis: this.soilAnalysis,
    });
  }

  formatCharacteristicValue = (value: number, designation: string): string =>
    value?.toFixed(this.getDecimalCount(designation)) ?? '-';

  getDecimalCount = (designation: string): number => {
    switch (designation) {
    case SoilAnalysisDesignations.cnRatio:
    case SoilAnalysisDesignations.nlv:
    case SoilAnalysisDesignations.nTot:
    case SoilAnalysisDesignations.nMinVrdVv:
    case SoilAnalysisDesignations.pAl:
    case SoilAnalysisDesignations.pw:
    case SoilAnalysisDesignations.kGetal:
      return 0;
    default:
      return 1;
    }
  };
}
